(function() {
  var $265fd73c1ba6bcfe$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("variant-picker")) return;
    customElements.define("variant-picker", class VariantPicker extends HTMLElement {
      connectedCallback() {
        this.productForm = this.closest("product-form");
        if (!this.productForm) return;
        this.invalidOptionMode = this.productForm.dataset.invalidOptionMode === "hide" ? "hide" : "disable";
        this.handleChange = this.handleChange.bind(this);
        this.addEventListener("change", this.handleChange);
        this.applyOptionAvailability();
        this.emitOptionsChange({
          updateUrl: false
        });
      }
      disconnectedCallback() {
        this.removeEventListener("change", this.handleChange);
      }
      handleChange(event) {
        const {target: target} = event;
        if (target.hasAttribute("data-ignore")) return;
        if (!target.name || !target.name.startsWith("option")) return;
        this.updateOptions(target);
        this.applyOptionAvailability();
        this.emitOptionsChange({
          updateUrl: true
        });
      }
      updateOptions(target) {
        this.querySelectorAll(`[data-option-title="${target.name}"]`).forEach(el => el.textContent = target.value);
        this.querySelectorAll(`[name="${target.name}"]`).forEach(el => {
          if (el.tagName === "SELECT") el.value = target.value; else el.checked = el.value === target.value;
        });
      }
      applyOptionAvailability() {
        const variants = this.productForm?.getVariantData?.() || [];
        const optionCount = variants[0]?.options?.length || 0;
        if (!optionCount) return;
        const selectedOptions = [ ...this.collectSelectedOptions() ];
        const isHideMode = this.invalidOptionMode === "hide";
        const experienceOptionIndex = this.productForm?.getProductFormStateData?.()?.event?.option_indices?.experience ?? -1;
        for (let optionPosition = 1; optionPosition <= optionCount; optionPosition += 1) {
          const inputs = Array.from(this.querySelectorAll(`input[name="option${optionPosition}"]`));
          if (!inputs.length) continue;
          const {comboValues: comboValues, availableValues: availableValues} = this.getOptionValueSetsForPosition(variants, selectedOptions, optionPosition);
          const isExperienceOption = optionPosition - 1 === experienceOptionIndex;
          const inputStates = new Map;
          inputs.forEach(input => {
            const isValidCombo = comboValues.has(input.value);
            const isAvailable = availableValues.has(input.value);
            const isOptionNotAvailable = isExperienceOption ? false : isHideMode ? !isValidCombo || !isAvailable : !isAvailable;
            const shouldHideInvalidOption = isExperienceOption ? false : isHideMode && !isValidCombo;
            const item = input.closest("[data-option-item]");
            const optionLabel = input.closest("label");
            inputStates.set(input, {
              shouldHideInvalidOption: shouldHideInvalidOption
            });
            input.disabled = shouldHideInvalidOption;
            optionLabel?.setAttribute("aria-disabled", String(shouldHideInvalidOption));
            optionLabel?.classList.toggle("pf-value--invalid", isOptionNotAvailable);
            if (item) {
              item.setAttribute("data-option-invalid", String(isOptionNotAvailable));
              item.setAttribute("aria-hidden", String(shouldHideInvalidOption));
            }
          });
          let selectedInput = inputs.find(input => input.checked && !inputStates.get(input)?.shouldHideInvalidOption);
          if (!selectedInput) {
            selectedInput = inputs.find(input => !inputStates.get(input)?.shouldHideInvalidOption);
            if (selectedInput) selectedInput.checked = true;
          }
          selectedOptions[optionPosition - 1] = selectedInput?.value || "";
        }
      }
      getOptionValueSetsForPosition(variants, selectedOptions, optionPosition) {
        const upstreamLength = optionPosition - 1;
        const comboValues = new Set;
        const availableValues = new Set;
        variants.forEach(variant => {
          let matchesUpstreamSelection = true;
          for (let index = 0; index < upstreamLength; index += 1) {
            const selectedValue = selectedOptions[index];
            if (selectedValue && variant.options[index] !== selectedValue) {
              matchesUpstreamSelection = false;
              break;
            }
          }
          if (!matchesUpstreamSelection) return;
          const optionValue = variant.options[optionPosition - 1];
          comboValues.add(optionValue);
          if (variant.available) availableValues.add(optionValue);
        });
        return {
          comboValues: comboValues,
          availableValues: availableValues
        };
      }
      collectSelectedOptions() {
        return Array.from(this.querySelectorAll('select[name^="option"],input[name^="option"]:checked'), el => el.value);
      }
      emitOptionsChange({updateUrl: updateUrl}) {
        this.dispatchEvent(new CustomEvent("variant-picker:options-change", {
          bubbles: true,
          detail: {
            options: this.collectSelectedOptions(),
            updateUrl: updateUrl
          }
        }));
      }
    });
  })();
})();